import React from "react";
import "./templateOne.css";
import { Box } from "@chakra-ui/react";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { convertAmountToWords } from "components/allForm/PaymentMode/helper";
import TermsAndConditions from "./commonComponent/termsAndConditions";
import BankDetails from "./commonComponent/bankDetails";
import { calculateItemGstAmount } from "../uttils/calculateItemGstAmount";
import BankDetailsWithProvidedData from "./commonComponent/bankDetailsWithDataProvided";

const ShowAddress = ({address}) => {
  if (!address) return {};
  const city = address.cityName;
  const country = address.countryName;
  const state = address.stateName;
  return (
    <>
      <p className="street1">{address?.s1}</p>
      <p className="street2">{address?.s2}</p>
      <p>
        {city}, {address?.pin}
      </p>
      <p className="dist">
        {state}, {country}
      </p>
    </>
  )
}

const InvoiceTemplateOne = ({
  title,
  idNo,
  invoice,
  invoiceDate,
  invoiceTerms,
  invoiceCurrency,
  invSub,
  itemList,
  currency,
  clientId,
  clientGst,
  gst,
  totalAmount,
  freightCharge,
  adjustment,
  customerNotes,
  totalPaymentAmount,
  total,
  dueDate,
  orgAddress,
  clientAddress,
  clientShippingAddress,
  clientDetail,
  logoUrl,
  organizationData,
  selectedBankDetails,
  isProforma
}) => {
  return (
    <div id="Template1" className="invoice">
      <h2 className="center fw-600">{title}</h2>
      <ShowAddress address={orgAddress} />
      <table className="main-table">
        <tbody>
          <tr>
            <td className="left-box address-td">
              <div className="address-box address1">
                <p className="name fw-600 mb-4">{organizationData?.name}</p>
                <p className="gst mt-4">GSTIN/UIN: {organizationData?.gstNo}</p>
              </div>
              <div className="address-box address2">
                <p className="fw-600">Bill To</p>
                <p className="name fw-600 mb-4">{clientDetail?.clName}</p>
                <ShowAddress address={clientAddress} />
                <p className="gst mt-4">GSTIN/UIN: {clientGst || "NA"}</p>
              </div>
              <div className="address-box address3">
                <p className="fw-600">Ship To</p>
                <p className="name fw-600 mb-4">{clientDetail?.clName}</p>
                <ShowAddress address={clientShippingAddress} />
              </div>
            </td>
            <td className="right-box">
              <table className="inner-table">
                <tbody>
                  <tr>
                    <td style={{ borderTop: "0px" }}>
                      <p>{invoice?.heading}</p>
                      <p className="fw-600">{invoice?.value}</p>
                    </td>
                    <td className="second-td" style={{ borderTop: "0px" }}>
                      <p>{invoiceDate?.heading}</p>
                      <p className="fw-600">{invoiceDate?.value}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>{invoiceTerms?.heading}</p>
                      <p className="fw-600">{invoiceTerms?.value}</p>
                    </td>
                    <td className="second-td">
                      <p>{invoiceCurrency?.heading}</p>
                      <p className="fw-600">{invoiceCurrency?.value}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Due Date</p>
                      <p className="fw-600">{dueDate?.value}</p>
                    </td>
                    <td className="second-td"></td>
                  </tr>
                  {invSub?.value && (
                    <tr>
                      <td colSpan={2} className="second-td">
                        <p>Subject:</p>
                        <p>{invSub?.value || "NA"}</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      <table className="line-items">
        <thead>
          <tr>
            <th className="slNo">Sl No.</th>
            <th className="particular">Particulars</th>
            <th className="hsn">Qty</th>
            <th className="hsn">Rate</th>
            <th className="text-center amt">Amount</th>
          </tr>
        </thead>
        <tbody>
          {itemList &&
            itemList?.length &&
            itemList.map((item) => {
              const calTax = formatAmountIndianRupees(calculateItemGstAmount(item) || 0);

              return (
                <tr>
                  <td className="slNo">1</td>
                  <td className="particular">
                    <p className="fw-600">{item?.slItm?.name}</p>
                    <p>{item?.slItm?.dc}</p>
                    <p>HSN/SAC - {item?.slItm?.hCd || item?.slItm?.sCd}</p>
                  </td>
                  <td>{item?.qty}</td>
                  <td>{formatAmountIndianRupees(item?.prc)}</td>
                  <td className="amt">
                    <p className="text-center fw-600">{formatAmountIndianRupees(item?.amt)}</p>
                  </td>
                </tr>
              );
            })}
          {currency.code === "INR" ? (
            <>
              {gst.type === "IGST" ? (
                <tr>
                  <td></td>
                  <td>
                    <p className="text-end fw-600">IGST</p>
                  </td>
                  <td></td>
                  <td></td>

                  <td>
                    <p className="fw-600">
                    {currency?.symbol || "₹"}{" "}
                    {formatAmountIndianRupees(gst?.amount?.i || 0)}{" "}
                    </p>
                  </td>
                </tr>
              ) : (
                <>
                  <tr>
                    <td></td>
                    <td>
                      <p className="text-end fw-600">CGST</p>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                     <p className="fw-600">
                      {currency?.symbol || "₹"}{" "}
                      {formatAmountIndianRupees(gst?.amount?.c || 0)}{" "}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <p className="text-end fw-600">SGST</p>
                    </td>
                    <td></td>
                    <td></td>

                    <td>
                      <p className="fw-600">
                      {currency?.symbol || "₹"}{" "}
                      {formatAmountIndianRupees(gst?.amount?.s || 0)}{" "}
                      </p>
                    </td>
                  </tr>
                </>
              )}
            </>
          ) : (
            ""
          )}

          {freightCharge ? (
            <tr>
              <td></td>
              <td>
                <p className="text-end fw-600">Freight Charges</p>
              </td>
              <td></td>
              <td></td>

              <td><p className="fw-600">{formatAmountIndianRupees(freightCharge)}</p></td>
            </tr>
          ) : (
            ""
          )}
          {adjustment?.value ? (
            <tr>
              <td></td>
              <td>
                <p className="text-end fw-600">{adjustment?.label}</p>
              </td>
              <td></td>
              <td></td>

              <td><p className="fw-600">{formatAmountIndianRupees(adjustment?.value)}</p></td>
            </tr>
          ) : (
            ""
          )}
          <tr className="total-row">
            <td> </td>
            <td colSpan="1" className="right-text">
              <strong>Total</strong>
            </td>
            <td></td>
            <td></td>

            <td>
              <strong>
                {currency?.symbol || "₹"}{" "}
                {formatAmountIndianRupees(totalPaymentAmount || 0)}{" "}
              </strong>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="section">
        <p className="fw-600">Amount Chargeable (in words):</p>
        <p className="mb-1">
          {currency?.code} {convertAmountToWords(totalPaymentAmount || 0)}
        </p>
      </div>

      <table className="tax-table">
        <thead>
          <tr>
            <th className="hsn text-center">HSN/SAC</th>
            <th className="taxable text-center">Taxable Value</th>
            <th className="text-center">Tax</th>
            {currency?.code === 'INR' && 
            <th className="text-center">
              {gst?.type === "IGST" ? "IGST" : "CGST & SGST"}
            </th>
            }
            <th className="taxable text-center">Total Tax Amount</th>
          </tr>
        </thead>
        <tbody>
          {itemList &&
            itemList?.length &&
            itemList.map((item, i) => {
              const calTax = formatAmountIndianRupees(calculateItemGstAmount(item) || 0);
              return (
                <tr>
                  <td>{item?.slItm?.hCd || item?.slItm?.sCd}</td>
                  <td className="text-center">{formatAmountIndianRupees(item?.amt || 0)}</td>
                  <td className="text-center">{item?.tax?.label || "-"}</td>
                  {currency?.code === 'INR' &&<td className="text-center">{calTax}</td>}
                  <td className="text-center">{formatAmountIndianRupees((parseFloat(item?.amt || 0) + parseFloat(calTax || 0)) || 0)}</td>
                </tr>
              );
            })}
          <tr className="total-row">
            <td>
              <p className="text-end mx-2 fw-600">Total</p>
            </td>
            <td><p className="text-center fw-600">{formatAmountIndianRupees(total?.amt)}</p></td>
            <td></td>
            {currency?.code === 'INR' &&<td className="text-center"><p className="fw-600">{formatAmountIndianRupees(total?.gstAmt)}</p></td>}
            <td><p className="text-center fw-600">{formatAmountIndianRupees(total?.amt + total?.gstAmt)}</p></td>
          </tr>
        </tbody>
      </table>

      <Box
        className="footer-grid"
        display="flex"
        // flexDirection="row"
        // justifyContent="space-between"
      >
        <div className="remarks pb-2">
          <TermsAndConditions isProforma={isProforma} />

          <p>{customerNotes}</p>
        </div>
        <div className="bank-details">
          <div className="details">
            {organizationData?.isBnk && <BankDetailsWithProvidedData bankDetails={selectedBankDetails} />}
          </div>
          <div className="signatory">
            <p className="p1">{organizationData?.name}</p>
            <p className="p2">Authorised Signatory</p>
          </div>
        </div>
      </Box>
      <p className="center small">
        {isProforma ? organizationData?.pfFtxt : organizationData?.sFtxt}
      </p>
    </div>
  );
};

export default InvoiceTemplateOne;
